var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"bimViewer-cont"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.showMask),expression:"setting.showMask"}],ref:"viewerMarkDom",staticClass:"mask"}),_c('div',{ref:"viewerDom",staticClass:"bimviewer_main"}),_c('bim-toolbar',{ref:"toolbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }